import accessKeySettings from './access-key';
import accessibilitySettings from './accessibility';
import agentAssistSettings from './agent-assist';
import almeApiSettings from './alme-api';
import analyticsSettings from './analytics';
import appEventSettings from './appevent-constants';
import buttonCollectionSettings from './button-collection';
import channelSettings from './channel-constants';
import classNames from './class-names';
import clientCommunicator from './client-communicator';
import elementDisabler from './element-disabler';
import elementIds from './element-ids';
import jwtAuthentication from './jwt-authentication';
import languageSettings from './language-constants';
import liveChatSettings from './livechat';
import markdown from './markdown';
import messageSettings from './message-constants';
import mobileSettings from './mobile-constants';
import multiTenantSettings from './multi-tenant';
import navSettings from './nav-constants';
import originSettings from './origin-constants';
import responseActionSettings from './response-action-constants';
import responseDropdown from './response-dropdown';
import responseLinks from './response-links';
import defaultSettings from './settings';
import stateLocations from './state-locations';
import stateTriggers from './state-triggers';
import textSettings from './text-constants';
import windowForm from './window-form';
import windowSettings from './window';
import * as merge from 'deepmerge';

const settings = {
    ...defaultSettings,
    ...accessKeySettings,
    ...accessibilitySettings,
    ...agentAssistSettings,
    ...almeApiSettings,
    ...analyticsSettings,
    ...appEventSettings,
    ...buttonCollectionSettings,
    ...channelSettings,
    ...classNames,
    ...clientCommunicator,
    ...elementDisabler,
    ...elementIds,
    ...jwtAuthentication,
    ...languageSettings,
    ...liveChatSettings,
    ...markdown,
    ...messageSettings,
    ...mobileSettings,
    ...multiTenantSettings,
    ...navSettings,
    ...originSettings,
    ...responseActionSettings,
    ...responseDropdown,
    ...responseLinks,
    ...stateLocations,
    ...stateTriggers,
    ...textSettings,
    ...windowForm,
    ...windowSettings,
};

export type DefaultSettings = typeof settings;

function overrideSettings(customSettings, subSettings = settings): void {
    for (const i in customSettings) {
        if (typeof subSettings[i] === 'undefined' || typeof subSettings[i] === 'string' ||
            typeof subSettings[i] === 'number' || typeof subSettings[i] === 'boolean' ||
            subSettings[i] === undefined || subSettings[i] == null
        ) {
            // Add any new settings or just set standard types.
            subSettings[i] = customSettings[i];
        } else {
            // Deep merge objects and arrays.
            subSettings[i] = merge.all([subSettings[i], customSettings[i]]);
        }
    }
}

function removeSettings(customSettings, subSettings = settings): void {
    for (const i in customSettings) {
        if (typeof customSettings[i] == "object") {
            //recursion
            removeSettings(customSettings[i], subSettings[i]);
        }
        else {
            //remove settings
            delete subSettings[i];
        }
    }
}

function getSettings(): DefaultSettings {
    return settings;
}

export { overrideSettings, settings, getSettings, removeSettings };



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/settings-util.ts